export type ResponseErrorType =
  | 'Unauthorized'
  | 'TokenNotFound'
  | 'NotSupported'
  | 'PersistingError'
  | 'RemovingError'
  | 'ValidationError'
  | 'UploadingError'
  | 'EntityNotFound'
  | 'TenantNotFound'
  | 'UnknownError'
  | 'invalid_grant'
  | 'CountryNotSupported'
  | 'DeviceNotSupported'
  | 'SubscriptionExceeded';

export class ErrorMessageResolverService {
  static getErrorMessage(error: any): string {
    const errorCode = error.status;
    const errorType: ResponseErrorType = error.error ? error.error.error : 'UnknownError';
    const errorDescription = error.error?.errorDescription || error.error?.error_description || error.error?.message || 'Unknown error';

    switch (true) {
      case errorCode === 400 && errorType === 'invalid_grant' && errorDescription === 'MFA verification code required.':
        return 'MFA verification code required.';
      case errorDescription && errorDescription !== 'Unknown error':
        return errorDescription;
      default:
        return 'An error occurred. Please try again later.';
    }
  }
}
